import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { logout as logoutApi } from "@/api/auth";
import { CURRENT_USER_QUERY_KEY } from "@/hooks/useCurrentUser";
import { useAuthStore } from "@/stores/auth";

/**
 * Logout side-effects: POST /api/auth/logout, clear Zustand, drop all query
 * cache (so the next login doesn't see stale per-user data), redirect to
 * /login. Returns the mutation so the caller can drive a Button.
 */
export function useLogout(): { logout: () => void; isPending: boolean } {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const clear = useAuthStore((s) => s.clear);

  const mutation = useMutation({
    mutationFn: logoutApi,
    onSettled: async () => {
      clear();
      queryClient.setQueryData(CURRENT_USER_QUERY_KEY, null);
      await queryClient.invalidateQueries();
      await navigate({ to: "/login" });
    },
  });

  return {
    logout: () => mutation.mutate(),
    isPending: mutation.isPending,
  };
}
